import { useContext } from 'react';
import { ChatApiContext } from '../chat_api_context.js';

const useChatApi = () => useContext(ChatApiContext);

export { useChatApi };
//# sourceMappingURL=use_chat_api.js.map
